import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useAsync } from "@utils/hooks";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { TertiaryButton } from "@ui/components/buttons/tertiaryButton";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap, mobile } from "@ui/styles/utils";
import { createToast } from "@ui/toasts/utils";

interface SpacesLimitModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const SpacesLimitModal: React.FC<SpacesLimitModalProps> = ({ close, ...htmlProps }) => {
	const { supportService } = useServices();
	const { run, loading } = useAsync(() => supportService.requestFeature("ADDITIONAL_WORKSPACES"), []);

	return (
		<Container close={close} title={I18n.t("shareroom.workspaces.limit_reached_modal.title")} {...htmlProps}>
			<Actions>
				{loading ? (
					<ClipLoader />
				) : (
					<TertiaryButton
						onClick={async () => {
							try {
								await run();
								createToast(I18n.t("success"), I18n.t("shareroom.workspaces.request.sent"), "success");
								close();
							} catch {
								createToast(I18n.t("error"), I18n.t("shareroom.workspaces.request.error"), "error");
							}
						}}
					>
						{I18n.t("shareroom.workspaces.limit_reached_modal.report")}
					</TertiaryButton>
				)}
				<SecondaryButton onClick={close}>{I18n.t("close")}</SecondaryButton>
			</Actions>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(25)};
	align-items: center;
	text-align: center;
`;

const Actions = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	flex-direction: column;
	${gap(25)};

	@media ${mobile} {
		${gap(15)};
		> button {
			padding: 12px 20px;
		}
	}
`;
